import { useMediaQuery } from 'react-responsive';
import ResetPassword from './ResetPassword';
import MobileReset from './MobileReset';

const ResetRouter = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 }); // adjust breakpoint if needed

  return isMobile ? <MobileReset /> : <ResetPassword />;
};

export default ResetRouter;
